import React, { useState, useRef, useEffect } from "react";
import ResourcesSubNav from "./ResourcesSubNav";
import Modal from "react-responsive-modal";
import { exitButton } from "_shared/modal";
import { findIndex, propEq } from "ramda";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import { user } from "../../_shared/auth";
import { ToTitleCase } from "_shared/helpers";
import { Scrollbars } from "react-custom-scrollbars";
import { getEnv } from "../../utils/constants";
import { get } from "_shared/request";
import useViewport from "_shared/useViewport";
import { hasSpecialChars } from "./Resource.helpers";

const ResourcesMobileSubNav = ({
  allTabs,
  setOpenResourcesMobileSubNav,
  ...rest
}) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const navigate = useNavigate();
  const ref = useRef(null);
  const { category } = useParams();
  const [currentTab, setCurrentTab] = useState([]);
  const { height } = useViewport();

  // const handleTabClick = (url) => {
  //   console.log("THIS IS URL ON TAB CLICK---");
  //   navigate(url);
  // };
  const { TeamId } = user;
  // uncomment to test all of the tabs
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const { data } = await get({ url: `resources/types/${TeamId}` });
  //       data.map((tab) => {
  //         const url = tab.Name.replace("/", "_").replace(/[\s/]+/gi, "-");
  //         tab.name = tab.Name;
  //         tab.url = `/resources/${url}`;
  //         return tab;
  //       });
  //       setCurrentTab(data);
  //     } catch (e) {
  //       console.log(e);
  //     }
  //   };
  //   fetchData();
  // }, []);

  const getNavLinkClass = (url) => currentPath.includes(url);

  const getTitleName = (Tab) => {
    const name = Tab.name;
    if (name === "Corporate IT" || name === "AppliedKids") return name;
    return ToTitleCase(name);
  };

  const Tabs = () =>
    allTabs.map((Tab, Index) => {
      const TitleCaseName = getTitleName(Tab);

      const urlName = Tab.name.replace(/\s+/gi, "-");
      const specialChar = hasSpecialChars(urlName);
      const url = `/resources/${
        specialChar ? encodeURIComponent(urlName) : urlName
      }`;

      return (
        <li
          ref={ref}
          key={Index}
          className={`${
            Tab.name === category
              ? "bg-teal-tints-10 font-bold [&>a]:text-primary"
              : ""
          } group flex list-none justify-between border-l-0 pl-4 [&_div]:cursor-pointer [&_div]:hover:cursor-pointer [&_i]:hover:cursor-pointer`}
        >
          <NavLink
            className="tab-name text-[#373D43]"
            onClick={() => {
              setOpenResourcesMobileSubNav(false);
            }}
            data-cy={`subnav-link`}
            to={url}
          >
            {Tab.name}
          </NavLink>
        </li>
      );
    });

  return (
    <div className="relative mx-auto bg-white ">
      <Scrollbars style={{ height: height - 75 }} universal={true}>
        <ul
          className="m-0 pl-0 [&_li:last-child]:border-b-0 
          [&_li]:border-b [&_li]:border-r-0
          [&_li]:border-t [&_li]:border-solid
          [&_li]:border-b-base-18 
          [&_li]:border-t-base-18
          [&_li]:py-3 
          [&_li]:text-[14px] [&_li_a]:focus:outline-none"
        >
          <Tabs />
        </ul>
      </Scrollbars>
    </div>
  );
};

export default ResourcesMobileSubNav;
